import clsx from "clsx";
import { Info } from "lucide-react";
import OverlayTrigger from "../../overlaytrigger";
import { ControlTooltipProps } from "../types";

export default function ControlTooltip(props: Readonly<ControlTooltipProps>) {
  const { label, error, description, url } = props;

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      overlayRole="tooltip"
      arrowProps={{
        fill: "white",
        strokeWidth: 1,
        stroke: "rgb(200 208 217)",
      }}
      overlay={
        <div className="max-w-[274px] bg-white border border-gunmetal-200 rounded-md">
          {!!label && (
            <div className="py-2 px-4 bg-gunmetal-50 font-medium text-gunmetal-700 border-b rounded-t-md border-gunmetal-200">
              {label}
            </div>
          )}
          <div className="p-4 text-xs leading-5">
            {description}
            {!!url && (
              <div>
                <br />
                <a href={url} target="#">
                  Edit {label}
                </a>
              </div>
            )}
          </div>
        </div>
      }
    >
      <Info
        className={clsx("transition-colors cursor-pointer", {
          "text-gunmetal-500": !error,
          "text-red-500": error,
        })}
        size="16"
      />
    </OverlayTrigger>
  );
}
